const home = {
  welcome: 'Bienvenue',
  glad: 'Content de te revoir !',
};

export default home;
